import { render, staticRenderFns } from "./ObserveListDetailsSectionContent.vue?vue&type=template&id=3156b036"
import script from "./ObserveListDetailsSectionContent.vue?vue&type=script&lang=js"
export * from "./ObserveListDetailsSectionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports